import { CountryRow, ScenarioId } from '../types/census';

export const SMARTPHONE_SHARE = 0.82;
export const GLOBAL_INTERNET_USERS = 6.12e9;
export const VERIFIABLE_AGENTS = 39.2e6;
export const AMBIENT_IOT = 21.1e9;

export const ENDPOINT_FORMULA = 'population × min(mobile per 100, 100) ÷ 100 × 0.82';
export const AGENTS_FORMULA = '(endpoints + internet users ÷ 6.12B × 39.2M) ÷ population';

export interface DerivedEstimates {
  internetUsers: number | null;
  smartphonePct: number | null;
  endpoints: number | null;
  createdAgents: number | null;
  agentsPerCapita: number | null;
}

export function deriveEstimates(population: number, internetPct: number | null, mobile: number | null): DerivedEstimates {
  const internetUsers = internetPct != null ? (population * internetPct) / 100 : null;
  const share = mobile != null ? (Math.min(mobile, 100) / 100) * SMARTPHONE_SHARE : null;
  const endpoints = share != null ? population * share : null;
  const createdAgents = internetUsers != null ? (internetUsers / GLOBAL_INTERNET_USERS) * VERIFIABLE_AGENTS : null;
  const agentsPerCapita = endpoints != null && population > 0 ? (endpoints + (createdAgents ?? 0)) / population : null;
  return { internetUsers, smartphonePct: share != null ? share * 100 : null, endpoints, createdAgents, agentsPerCapita };
}

export function agentsPerCapitaFor(row: CountryRow, scenario: ScenarioId): number | null {
  const m = countryMachines(row, scenario);
  return m != null && row.population > 0 ? m / row.population : null;
}

export const SCENARIO_AGENT_FORMULA: Record<ScenarioId, string> = {
  verifiable: 'internet users ÷ 6.12B × 39.2M created agents ÷ population',
  device: AGENTS_FORMULA,
  ambient: '(endpoints + created + internet-user share × 21.1B IoT) ÷ population',
};

export function countryMachines(row: CountryRow, scenario: ScenarioId): number | null {
  const created = row.createdAgents;
  if (created == null) return null;
  if (scenario === 'verifiable') return created;
  const withDevices = created + (row.endpoints ?? 0);
  if (scenario === 'device') return withDevices;
  const iot = row.internetUsers != null ? (row.internetUsers / GLOBAL_INTERNET_USERS) * AMBIENT_IOT : 0;
  return withDevices + iot;
}
